/**
 * Chess Board Component (Tailwind CSS)
 * Tailwind variant - uses Tailwind grid classes
 */
import type { BoardProps } from "../../types";
import { SquareTailwind } from "../square";
import { BoardBase } from "./BoardBase";

export function BoardTailwind(props: BoardProps) {
  const containerClasses = "chess-board";

  return (
    <BoardBase
      {...props}
      renderSquare={({
        file,
        rank,
        piece,
        isSelected,
        isLegalMove,
        isCapture,
        onClick,
      }) => (
        <SquareTailwind
          key={`${file}${rank}`}
          file={file}
          rank={rank}
          piece={piece}
          isSelected={isSelected}
          isLegalMove={isLegalMove}
          isCapture={isCapture}
          onClick={onClick}
          isMyTurn={props.isMyTurn}
          gameEnded={props.gameEnded}
        />
      )}
      className={containerClasses}
    />
  );
}
